// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3maoE","rootSuccess":"CompleteLink_rootSuccess__wleX5","rootFailure":"CompleteLink_rootFailure__2Jg14","isDisabled":"CompleteLink_isDisabled__1RRej"};